import React from 'react';
import Helper from '../Helper';

type CachedLinkHref = React.AnchorHTMLAttributes<HTMLAnchorElement>['href'] | (() => void);

export type CachedLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'> & {
    href?: CachedLinkHref;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement> | null) => void;
};

function getFileNameFromUrl(fileUrl: string): string {
    try {
        const url = new URL(fileUrl, window.location.origin);
        const pathname = url.pathname;
        const lastSegment = pathname.split('/').filter(Boolean).at(-1) ?? 'download';
        const extension = lastSegment.includes('.') ? `.${lastSegment.split('.').pop()}` : '';
        const baseName = lastSegment.includes('.')
            ? lastSegment.slice(0, lastSegment.lastIndexOf('.'))
            : lastSegment;

        const cleanedBaseName = baseName.includes('-')
            ? baseName.split('-').slice(0, -1).join('-') || baseName
            : baseName;

        return `${cleanedBaseName}${extension}`;
    } catch {
        const fallback = fileUrl.split('/').filter(Boolean).at(-1) ?? 'download';
        const extension = fallback.includes('.') ? `.${fallback.split('.').pop()}` : '';
        const baseName = fallback.includes('.')
            ? fallback.slice(0, fallback.lastIndexOf('.'))
            : fallback;

        const cleanedBaseName = baseName.includes('-')
            ? baseName.split('-').slice(0, -1).join('-') || baseName
            : baseName;

        return `${cleanedBaseName}${extension}`;
    }
}

async function downloadAndOpenFileWithCache(fileUrl: string, fileName: string): Promise<void> {
    try {
        const resolvedFileName = fileName || getFileNameFromUrl(fileUrl);
        const blob = await Helper.downloadFileWithCache(fileUrl, resolvedFileName, null);

        if (!blob) {
            return;
        }

        const safeFileName = getFileNameFromUrl(fileUrl);
        const pdfBlob = blob.type && blob.type.toLowerCase().includes('pdf')
            ? blob
            : new Blob([blob], { type: 'application/pdf' });

        const localUrl: string = URL.createObjectURL(pdfBlob);

        const newWindow: Window | null = window.open(localUrl, '_blank', 'noopener,noreferrer');
        if (!newWindow) {
            console.warn('Popup blocker prevented opening the file.');
            const downloadLink: HTMLAnchorElement = document.createElement('a');
            downloadLink.href = localUrl;
            downloadLink.download = safeFileName;
            downloadLink.rel = 'noopener noreferrer';
            document.body.appendChild(downloadLink);
            //downloadLink.click();
            document.body.removeChild(downloadLink);
        }

        setTimeout(() => URL.revokeObjectURL(localUrl), 10000);
    }
    catch (error: unknown) {
        if (error instanceof Error) {
            console.error('File operation failed:', error.message);
        } else {
            console.error('An unexpected error occurred:', error);
        }
    }
}

const CachedLink = React.memo(function CachedLink({ children, href,  onClick, ...anchorProps }: CachedLinkProps) {
    //const { refreshRequired } = useOnlineStatus();

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
        if (typeof href === 'function') {
            event.preventDefault();
            href();
        } else if (typeof href === 'string') {
            event.preventDefault();
            if (href !== '#') {
                // if (refreshRequired) {
                //     if (onClick) {
                //         onClick(event);
                //         return;
                //     }
                //     window.open(href, '_blank', 'noopener,noreferrer');
                //     return;
                // }
                downloadAndOpenFileWithCache(href, getFileNameFromUrl(href));
                return;

                // if (onClick) {
                //     onClick(event);
                //     return;
                // }
                // window.open(href, '_blank', 'noopener,noreferrer');
                // return;
            }
            else if (onClick) {
                onClick(event);
                return;
            }

            //window.open(href, '_blank', 'noopener,noreferrer');
        }
        onClick?.(event);
    };

    return (
        <a {...anchorProps} href={typeof href === 'string' ? href : undefined} onClick={handleClick} target="_blank" rel="noreferrer">
            {children}
        </a>
    );
});

// const CachedLink = function CachedLink({ children, href, onClick, ...anchorProps }: CachedLinkProps) {
//     return (
//         <a
//             {...anchorProps}
//             href={typeof href === 'string' && !Helper.isViator(href) ? href : undefined}
//             onClick={(event) => {
//                 if (typeof href === 'function') {
//                     event.preventDefault();
//                     href();
//                     return;
//                 }
//                 else if (typeof href === "string" && Helper.isViator(href)) {
//                     downloadAndOpenFileWithCache(href, new URL(href).pathname);
//                     return;
//                 }

//                 if (onClick) {
//                     onClick(event);
//                 }
//             }}
//         >
//             {children}
//         </a>
//     );
// };


export default CachedLink;